import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { hideDialog } from "../../../redux/guest-slices/other.slice";
import Icons from "../../../assets/js/Icons";

function FeatureGuardDialog() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data } = useSelector(
    (state) => state.otherSlice
  );

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const handleUpgrade = () => {
    handleClose();
    navigate("/pricing");
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {data?.title || "Upgrade Required"}
        </Typography>

        <IconButton
          sx={{
            top: 10,
            right: 10,
            position: "absolute",
          }}
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          textAlign="center"
          fontSize={16}
        >
          {data?.description ||
            "Your current plan does not include access to this feature."}
        </Typography>

        <Typography
          textAlign="center"
          mt={3}
          color="primary.main"
          fontWeight={600}
        >
          {data?.requiredPlan &&
            `Available in ${data.requiredPlan} plan and above`}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleClose}
        >
          Maybe Later
        </Button>

        <Button
          variant="contained"
          onClick={handleUpgrade}
        >
          View Plans
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default FeatureGuardDialog;